// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_3DMH1ptgjYEsyGhN7sDMfI"};